import React from 'react';

import { Column, ColumnProps } from '../Grid/Column';

export const Header: React.FC<ColumnProps> = props => <Column as="header" width={12} className="pad-m" {...props} />;
